import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/Main';

import {kindergartenOuterRouterList, kindergartenMainRouterList} from "./kindergarten";
import {primaryOuterRouterList, primaryMainRouterList} from "./primary";


Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/main'
        }, {
            path: '/main',
            name: 'main',
            component: Main,
            children: [
                ...primaryMainRouterList,
                ...kindergartenMainRouterList
            ]
        },
        ...kindergartenOuterRouterList,
        ...primaryOuterRouterList
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js